export const NAME = 'releasenotes';